import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Maldives: Country = {
    identifier: "Maldives",
    name: "Maldives",
    countryCode: "MV",
    group: CountryGroup.ASIA,
    isUNMember: true,
    flag: "🇲🇻",
    svgPath: "m 681.20675,451.3024 -0.049,0.026 -0.046,-0.01 -0.016,-0.033 0.023,-0.048 0.038,-0.063 0.026,-0.068 0.038,-0.036 0.029,0.012 -0.003,0.038 -0.014,0.052 -0.009,0.068 -0.017,0.062 z m -0.269,2.607 -0.06,0.005 -0.037,-0.048 0.008,-0.069 0.047,-0.049 0.073,-0.003 0.042,0.043 -0.021,0.067 -0.052,0.054 z",
}
